import Vue from 'vue'
import Vuex from 'vuex'
import auth from '../api/auth'
import dataUser from '../api/dataUser'
import dataApp from '../api/app'
import checkout from '../api/checkout'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    drawer: true,
    user: null,
    userRegister: null,
    loading: false,
    routesName: ['Home', 'About', 'Contact', 'Rescue', 'RegisterStudent'],
    userData: [],
    products: null,
    licenses: null,
    notifications: [],
    dataGroupSelected: [],
    dataUserAdmin: [],
    adminUsers: [],
    purchaseData: []
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_USER (state, user) {
      state.user = user
      state.loading = false
    },
    SET_DATA_USER_ADMIN (state, admin) {
      state.dataUserAdmin = admin
      state.loading = false
    },
    SET_ADMIN_USERS (state, users) {
      state.adminUsers = users
      state.loading = false
    },
    SET_UPDATE_USER (state, dataUser) {
      state.userData.firstname = dataUser.firstname
      state.userData.lastname = dataUser.lastname
      state.userData.birth_date = dataUser.birth_date
      state.userData.location = dataUser.location
      state.user.name = `${dataUser.firstname} ${dataUser.lastname} `
      state.loading = false
    },
    SET_LICENSES (state, licenses) {
      state.licenses = licenses
    },
    SET_PRODUCTS (state, products) {
      state.products = products
    },
    SET_USER_REGISTER (state, userRegister) {
      state.userRegister = userRegister
    },
    SET_LOADING (state, active) {
      state.loading = active
    },
    SET_USER_DATA (state, payload) {
      state.userData = payload
      state.loading = false
    },
    SET_NOTIFICATIONS (state, payload) {
      state.notifications = payload
    },
    ADD_GROUP_USER (state, payload) {
      state.userData.groups.push(payload)
    },
    SET_GROUP_USER (state, payload) {
      state.userData.groups = payload
    },
    SET_DATA_GROUP (state, payload) {
      state.dataGroupSelected = payload
    },
    SET_PURCHASE_DATA (state, purchaseData) {
      state.purchaseData = purchaseData
    },
  },
  actions: {
    async SIGN_IN (context, payload) {
      const response = await auth.signIn(payload)
      response === 'error' ? context.commit('SET_LOADING', false) : context.commit('SET_USER', response)
    },
    async SIGN_OUT (context) {
      await auth.signOut()
      context.commit('SET_LOADING', false)
    },
    async SEND_FORGOT_EMAIL (context, payload) {
      context.commit('SET_LOADING', true)
      await auth.sendForgotEmail(payload)
      context.commit('SET_LOADING', false)
    },
    async GET_USER (context, payload) {
      const response = await auth.getUser(payload)
      if (response === 'error') {
        context.commit('SET_LOADING', false)
      } else {
        // this.dispatch('GET_USER_DATA', response)
        this.dispatch('GET_PRODUCTS')
        this.dispatch('GET_ALL_LICENSES_USER', response.uid)
        context.commit('SET_USER', response)
      }
    },
    async UPDATE_USER (context, payload) {
      const response = await auth.updateUser(payload)
      if (response !== 'Ok') {
        context.commit('SET_LOADING', false)
        alert('Ha ocurrido un error', response)
      } else {
        context.commit('SET_UPDATE_USER', payload)
        alert('Usuario actualizado con éxito!', response)
      }
    },
    async UPDATE_USER_NOTIFICATIONS (context, payload) {
      const data = {
        uid: context.state.user.uid,
        notifications: payload,
      }
      const response = await auth.updateNotifications(data)
      if (response !== 'Ok') {
        alert('Ha ocurrido un error', response)
      } else {
        alert('Invitación actualizada con éxito!', response)
      }
    },
    async UPDATE_STUDENT_INVITATION (context, payload) {
      const response = await auth.updateInvitationStudent(payload)
      if (response !== 'Ok') {
        alert('Ha ocurrido un error', response)
      } else {
        await this.dispatch('GET_USER_DATA')
        console.log('Estudiante actualizado con Éxito!!!')
      }
    },
    async UPDATE_TUTOR_PERMISION (context, payload) {
      const response = await dataUser.updatePermissionTutor(payload)
      if (response !== 'Ok') {
        alert('Ha ocurrido un error', response)
      } else {
        await this.dispatch('GET_USER_DATA')
        alert('Permisos actualizados con Éxito!!!')
      }
    },
    async GET_PRODUCTS (context) {
      const response = await dataApp.getProducts()
      context.commit('SET_PRODUCTS', response)
    },
    async REGISTER (context, payload) {
      const response = await auth.register(context.state.userRegister)
      response === 'error' ? context.commit('SET_LOADING', false) : context.commit('SET_USER', response)
    },
    async UPDATE_PASS (context, payload) {
      await auth.updatePass(payload)
      context.commit('SET_LOADING', false)
    },
    async GET_USER_DATA (context) {
      context.commit('SET_LOADING', true)
      const response = await dataUser.getUserData()
      context.commit('SET_USER_DATA', response)
      return response
    },
    async CREATE_GROUP (context, payload) {
      const data = {
        groupNew: payload,
        uid: context.state.user.uid,
      }
      await dataUser.setCreateGroup(data)
      context.commit('ADD_GROUP_USER', payload)
    },
    async EDIT_GROUP (context, payload) {
      context.commit('SET_GROUP_USER', payload)
      const data = {
        groups: payload,
        uid: context.state.user.uid,
      }
      await dataUser.setEditGroup(data)
      const response = await dataUser.getUserData()
      context.commit('SET_USER_DATA', response)
    },
    async GET_STUDENT (context, payload) {
      context.commit('SET_LOADING', true)
      const res = await dataUser.getStudent(payload)
      context.commit('SET_LOADING', false)
      return res
    },
    async GET_STUDENTS_BY_GROUP (context, payload) {
      context.commit('SET_LOADING', true)
      const data = {
        groupId: payload,
        uid: context.state.user.uid,
      }
      const res = await dataUser.studentsByGroup(data)
      context.commit('SET_LOADING', false)
      return res
    },
    async GET_ALL_LICENSES_USER (context, payload) {
      const res = await dataUser.getLicense(payload)
      context.commit('SET_LICENSES', res)
    },
    async GET_ADMIN_DATA () {
      await dataUser.getAdminData()
    },
    async ASSIGN_LICENSE (context, data) {
      const res = await dataUser.agregateLicenseUser(data)
      if (res === 'ok') {
        alert('Licencia agregada!')
      } else {
        alert('Error! Solicitud no procesada :(')
      }
      context.commit('SET_LOADING', false)
    },
    async IS_TUTOR_EXIST (context, payload) {
      const isExist = await dataApp.isTutorExist(payload)
      return isExist
    },
    async GET_PURCHASE_DATA (context) {
      const res = await dataUser.getPurchaseData()
      context.commit('SET_LICENSES', res)
    },
    async CREATE_CHECKOUT (context, productId) {
      const userId = context.state.user.uid;
      const email = context.state.user.email;
      const res = await checkout.createCheckout(userId, email, productId);
      // context.commit('SET_LOADING', false);
      return res;
    }
  },
  getters: {
    getDataGroupSelected: state => {
      return state.dataGroupSelected
    },
  },
})
